import { Service } from '@roc/client-portal-shared/services';

const url = {
  REFERRAL_FEE_LINK: `/api/v1/document/formDocument/getReferralFeeLink`,
  GET_BANK_INFO: `/api/v1/document/formDocument/getBankInformation`,
  APPROVE_BANK_INFO: `/api/v1/loan/approveEntityBankInformation`,
};

export class ReferralFeeExternalService extends Service {
  getReferralFeeLink(loanId: string) {
    return this.get(`${url.REFERRAL_FEE_LINK}?loanId=${loanId}`);
  }

  /** The loan's broker's bank details; the loan is required for non-staff users. */
  getBankInfo(entityId: string, loanId: string) {
    return this.get(`${url.GET_BANK_INFO}?entityId=${entityId}&entityType=BrokerEntity&loanId=${loanId}`);
  }

  approveBankInformation(entityId: string) {
    return this.get(`${url.APPROVE_BANK_INFO}?entityId=${entityId}&entityType=BrokerEntity`);
  }
}
